import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ALL_DISCHARGE_LOGS, BASE_URL, MARK_AS_READ_DISCHARGE_LOG } from 'src/app/endpoints';

@Injectable({
  providedIn: 'root'
})
export class DischargeLogsService {
  constructor(private http: HttpClient) { }

  getAllDischargeLogs(data: any) {
    return this.http.post<any>(BASE_URL + ALL_DISCHARGE_LOGS, data);
  }

  markAsRead(logId: string) {
    return this.http.post<any>(BASE_URL + MARK_AS_READ_DISCHARGE_LOG, { logId });
  }
}
